// import API from '@/api/wareHouse/supplierDeliveryOrder.js';
import { filterEmpty } from '@/common/js/util';
import ORDER_API from '@/api/purchaseSalesCenter/purchaseSales.js';
import { formatDate } from '@/utils';
export default {
  data() {
    return {
      baseFormData: {},
      attachments: [], // 上传列表
      orderContractRelationshipList: [],
      orderDetailList: [],
      orderDetailDelIds: [],
      detailPageData: {},
      // 当前单状态
      contractStatus: '',
      orderInterest: {},
      isDisabledPricingRule: true,
      contractTotalAmount: null,
      isFixedPrice: null,
      isRestrict: '',
      orderOverdueInterestList: [],
    };
  },
  methods: {
    //上传回调
    handleUpload(uploadTableData) {
      this.attachments = uploadTableData;
    },
    isRestrictHandler(val) {
      console.log(val, '??');
      this.isRestrict = val;
    },
    // 获取数据
    async getOrderDetail() {
      this.loading.startLoading();
      let postData = {
        contractNo: this.$route.query.contractNo,
        dataGroup: this.$globalVar.dataGroup,
        copyFlag: this.$route.query.copyFlag,
      };
      if (
        this.$route.query.relationContractDetailCategory &&
        this.$route.query.relationContractDetailCategory.length
      ) {
        postData.relationContractDetailCategory = this.$route.query.relationContractDetailCategory;
        postData.copyFlag = '1';
      }
      const { data } = await this.$axios.post(ORDER_API.GET_ORDER_DETAIL_API, postData);
      console.log(data, '获取到的数据');
      this.loading.endLoading();
      if (data.code == 0) {
        // 反填表单数据
        let {
          version,
          contractCreateDate,
          contractNo,
          contractName,
          customerName,
          customerNo,
          projectInitiationNo,
          projectName,
          contractBusinessDepartment,
          contractBusinessDepartmentName,
          contractBusinessCompanyNo,
          contractBusinessCompanyName,
          companyCode,
          companyName,
          signDate,
          contractValidStart,
          contractValidEnd,
          contractOperaterName,
          recyclingCompanyFileNo,
          recyclingCompanyName,
          platformCompanyFileNo,
          platformCompanyName,
          isFixedPrice,
          isRelatedParty,
          pricingRule,
          contractCurrency,
          personChargeCode,
          personChargeName,
          receiptMethod,
          contractTotalAmount,
          overShippedPercentage,
          shortShippedPercentage,
          performanceBondPayMethodCode,
          performanceBondPayMethodName,
          performanceBond,
          warrantyClause,
          contractStatus,
          marginAmount,
          id,
          companyCurrency,
          companyCurrencyName,
          contractCurrencyName,
          attachmentList,
          orderContractRelationshipList,
          orderDetailList,
          orderOverdueInterestList,
          orderInterest,
          businessContractTotalAmount,
          mark,
          isRestrict,
          externalContractNo,
          generateNo,
        } = data.data;

        //COPY的情况后端会清空
        if (this.$route.query.copyFlag && this.$route.query.copyFlag == '0') {
          companyName = this.userInfo.companyName;
          companyCode = this.userInfo.companyCode;
          contractStatus = '';
        }
        if (!contractStatus) {
          contractStatus = '';
        }
        // this._getDepartmentByCompanyCodeApi(companyCode);
        // this._getSupplierApi(companyCode);
        this.orderDetailList = orderDetailList ? orderDetailList : []; // 产品明细
        this.orderOverdueInterestList = orderOverdueInterestList ? orderOverdueInterestList : []; //
        // this.orderDetailList.map((item) => {
        //   if (item.priceConfirmDate == null) {
        //     item.priceConfirmDate = new Date();
        //   }
        //   if (item.businessChangeUnitPrice == null) {
        //     item.businessChangeUnitPrice = 0;
        //   }
        // });
        this.orderContractRelationshipList = orderContractRelationshipList
          ? orderContractRelationshipList
          : []; // 关联明细
        this.attachments = attachmentList ? attachmentList : []; // 附件
        this.contractStatus = contractStatus; // 当前单的状态
        this.detailPageData = data.data; // 全部数据
        this.orderInterest = orderInterest; // 逾期利息
        this.isRestrict = isRestrict + '';
        // 表单
        this.baseFormData = {
          ...this.baseFormData,
          version,
          contractCreateDate,
          contractNo,
          contractName,
          customerName,
          customerNo,
          projectInitiationNo,
          projectName,
          contractBusinessDepartment,
          contractBusinessDepartmentName,
          contractBusinessCompanyNo,
          contractBusinessCompanyName,
          companyCode,
          companyName,
          signDate,
          contractValidStart,
          contractValidEnd,
          contractOperaterName,
          recyclingCompanyFileNo,
          recyclingCompanyName,
          platformCompanyFileNo,
          platformCompanyName,
          isFixedPrice: isFixedPrice + '',
          isRelatedParty,
          pricingRule,
          contractCurrency,
          companyCurrency,
          companyCurrencyName,
          contractCurrencyName,
          personChargeCode,
          personChargeName,
          receiptMethod,
          contractTotalAmount: this.replaceZeroStr(contractTotalAmount),
          businessContractTotalAmount,
          overShippedPercentage,
          shortShippedPercentage,
          performanceBondPayMethodCode,
          performanceBondPayMethodName,
          performanceBond,
          warrantyClause,
          marginAmount,
          contractStatus,
          id,
          mark,
          isRestrict,
          externalContractNo,
          generateNo,
        };
      } else {
        this.$message.error(data.msg);
      }
    },
    // 按钮组事件派发
    btnClickHandler(clickName, param) {
      this[clickName](param);
    },

    confirmCancelHandler(type) {
      this.revert(type);
    },
    rejectCancelHandler(type) {
      this.revert(type);
    },

    // 撤回审批
    withdrawApprovalHandler() {
      this.loading.startLoading();
      this.$axios
        .post('/sales/order/batchAuditWithdrawOA', {
          contractNos: [this.$route.query.contractNo],
          oaId: this.userInfo.oaId,
        })
        .then((res) => {
          this.loading.endLoading();
          console.log(res);
          const { code, msg } = res.data;
          if (code == 0) {
            this.$message.success('撤回成功');
            this.$store.dispatch('tagsView/delView', {
              path: '/salePurchase/saleContractEdit',
              name: 'saleContractEdit',
              meta: {
                keepAlive: false,
                title: '',
              },
              query: {},
            });
            this.$router.push({ path: '/salePurchase/saleOverview' });
          } else {
            this.$message.error(msg);
          }
        })
        .catch(() => {
          this.loading.endLoading();
        });
    },
    tableDeleteNotifier(ids) {
      if (ids && ids.length) {
        this.orderDetailDelIds = [...this.orderDetailDelIds, ...ids];
        console.log('deleted ids', this.orderDetailDelIds);
        this.orderDetailList = this.orderDetailList.filter(
          (item) => !this.orderDetailDelIds.includes(item.id)
        );
      }
    },
    revert(type) {
      //1确认0驳回
      //approvaResult  审批状态 1通过 0不通过

      const generateNo = this.baseFormData.generateNo;
      const message =
        type == 1 && generateNo ? `同时撤回关联合同号${generateNo}` : '确定要更改合同状态';
      this.$confirm(message, '确认更改状态', {})
        .then(async () => {
          this.loading.startLoading();
          let params = {
            id: Number(this.$route.query.id),
            approvaResult: type == 0 ? '0' : '1',
            oaId: this.userInfo.oaId,
          };

          this.$axios.post('/sales/order/approvalOrderStatusForUndo', params).then((res) => {
            if (res.data.code == 0) {
              this.$message({
                showClose: true,
                message: res.data.msg,
                type: 'success',
              });
              // this.getOrderDetail();
              //确认撤销后，刷新页面可编辑
              if (type == 1) {
                let query = this.$router.history.current.query;
                let path = this.$router.history.current.path;
                //对象的拷贝
                let newQuery = JSON.parse(JSON.stringify(query));
                newQuery.isEdit = false;
                this.$router.push({ path, query: newQuery });
              }
              this.getOrderDetail();
            } else {
              this.$message({
                showClose: true,
                message: res.data.msg,
                type: 'error',
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消',
          });
        });
    },

    //保存和提交 0是保存,1是提交
    async handleSave(type) {
      this.$refs.formItem.validate(async (valid, formData) => {
        if (valid) {
          console.log(formData, '--表单数据->>', formData.contractCreateDate);
          // console.log(this.$refs.upload.)
          const extendData = {
            departmentCode: this.userInfo.departmentCode,
            departmentName: this.userInfo.departmentName,
            companyName: this.userInfo.companyName,
            companyCode: this.userInfo.companyCode,
          };
          const orderContractRelationshipList = this.$refs.relationInfo
            .getTableData()
            .map((item) => {
              return {
                ...item,
                ...extendData,
              };
            });
          // 关联明细
          let orderDetailList = [];
          if (this.$route.query.type == 'CG03') {
            // 如果是协议的时候
            orderDetailList = this.$refs.agreementTable?.getTableData().map((item) => {
              return {
                ...item,
                priceConfirmDate: formatDate(item.priceConfirmDate || new Date()),
                ...extendData,
                taxRate: 0,
                productQuantity: item.productQuantity || 0,
              };
            });
          } else if (this.$route.query.type == 'CG04') {
            // 销售合同
            const { tableData } = await this.$refs.contractTableRef?.getTableData();
            orderDetailList = tableData.map((item) => {
              return {
                ...item,
                priceConfirmDate: formatDate(item.priceConfirmDate || new Date()),
                ...extendData,
              };
            });
          }
          // 删除orderDetailList中的gmtModified 字段
          orderDetailList = orderDetailList.map((item) => {
            delete item.gmtModified;
            return {
              ...item,
              businessContractUnitPrice: item.businessContractUnitPrice
                ? item.businessContractUnitPrice
                : 0,
              businessChangeTotalAmount: 0,
              businessContractTotalAmount: item.businessContractTotalAmount
                ? item.businessContractTotalAmount
                : 0,
              businessContractTaxAmount: item.businessContractTaxAmount
                ? Number(item.businessContractTaxAmount).toFixed(6)
                : 0, // ?
              businessContractPureAmount: 0, // ?
              businessChangeUnitPrice: item.businessChangeUnitPrice
                ? item.businessChangeUnitPrice
                : 0,
              businessChangeTaxAmount: 0, // ?
              businessChangePureAmount: 0, // ?
            };
          });
          if (orderDetailList.length == 0) {
            this.$message({
              type: 'error',
              message: '请添加产品明细',
            });
            return;
          }
          // 附件
          const attachmentList = this.$refs.fileTableRef?.getTableData().map((item) => {
            return {
              ...item,
              ...extendData,
            };
          });
          // 产品明细
          // let orderInterest = {
          //   ...this.detailPageData.orderInterest,
          //   ...extendData,
          // }; // 默认是之前的(后端要求的)
          console.log(1111);
          const taleData = await this.$refs.overdueInterestTableRef.getValidateTableData();
          console.log('222', taleData.orderOverdueInterestList);
          console.log(this.$route.query.copy, '??', this.$route.query.copy == true);
          const orderOverdueInterestList = taleData.orderOverdueInterestList.map((item) => {
            return {
              ...item,
              id:
                ['true', true].includes(this.$route.query.copy) ||
                ['true', true].includes(this.$route.query.isCopy)
                  ? ''
                  : item.id,
            };
          });
          console.log(attachmentList, '附件', orderOverdueInterestList);
          // 开票要求
          if (typeof formData.contractCurrency !== 'string') {
            formData.companyCurrency = formData?.contractCurrency?.currencyCode;
            formData.companyCurrencyNam = formData?.contractCurrency?.currencyName;
            formData.contractCurrency = formData?.contractCurrency?.currencyCode;
            formData.contractCurrencyNam = formData?.contractCurrency?.currencyName;
          }
          if (typeof formData.customerName != 'string') {
            formData.customerNo = formData.customerName?.partnerCode;
            formData.customerName = formData.customerName?.partnerZhName;
          }
          if (typeof formData.projectInitiationNo != 'string') {
            formData.projectInitiationNo = formData.projectInitiationNo?.projectCode;
            formData.projectName = formData.projectInitiationNo?.projectName;
          }

          if (formData.isFixedPrice) {
            formData.isFixedPrice = Number(formData.isFixedPrice);
          } else {
            formData.isFixedPrice = 0;
          }

          if (formData.overShippedPercentage) {
            formData.overShippedPercentage = Number(formData.overShippedPercentage).toFixed(2);
          }
          if (formData.shortShippedPercentage) {
            formData.shortShippedPercentage = Number(formData.shortShippedPercentage).toFixed(2);
          }

          if (formData.performanceBond) {
            formData.performanceBond = Number(formData.performanceBond).toFixed(2);
          }

          this.loading.startLoading();
          // const contractCreateDate = formData.contractCreateDate
          //   ? formatDate(formData.contractCreateDate, false)
          //   : null;
          // console.log(
          //   contractCreateDate,
          //   '==制单时间=>>>',
          //   formData.contractCreateDate,
          //   formatDate(formData.contractCreateDate, false)
          // );

          const businessContractUnitPrice = orderDetailList.reduce(
            (cur, next) => cur + +next.businessContractUnitPrice,
            0
          );
          const businessContractTotalAmount = orderDetailList.reduce(
            (cur, next) => cur + +next.businessContractTotalAmount,
            0
          );
          const businessContractTaxAmount = orderDetailList.reduce(
            (cur, next) => cur + next.businessContractTaxAmount,
            0
          );
          const businessContractPureAmount = orderDetailList.reduce(
            (cur, next) => cur + next.businessContractPureAmount,
            0
          );
          const businessChangeUnitPrice = orderDetailList.reduce(
            (cur, next) => cur + +next.businessChangeUnitPrice,
            0
          );
          const businessChangeTotalAmount = orderDetailList.reduce(
            (cur, next) => cur + +next.businessChangeTotalAmount,
            0
          );
          const businessChangeTaxAmount = orderDetailList.reduce(
            (cur, next) => cur + next.businessChangeTaxAmount,
            0
          );
          const businessChangePureAmount = orderDetailList.reduce(
            (cur, next) => cur + next.businessChangePureAmount,
            0
          );
          // 处理表格中数量问题
          const total = orderDetailList.reduce((cur, next) => cur + +next.productQuantity, 0);
          // 后端要求删除字段
          // delete orderInterest.gmtModified;
          // 重新计算销售合同中的 合同总金额
          // const contractTotalAmount = orderDetailList.reduce(
          //   (cur, next) => cur + +next.businessContractTotalAmount,
          //   0
          // );
          const contractTotalAmount = formData.contractTotalAmount;
          let postData = {
            ...filterEmpty(formData),
            isRestrict: ['0', '1'].includes(formData?.isRestrict) ? +formData?.isRestrict : '',
            purchaseQuantity: total + '' == 'NaN' ? 0 : total + '',
            // 签署日期
            signDate: formData.signDate ? `${formData.signDate}` : null,
            // 特殊处理下协议的时候
            contractTotalAmount:
              this.$route.query.type == 'CG03'
                ? 0
                : contractTotalAmount + '' == 'NaN'
                ? 0
                : contractTotalAmount,
            totalAmount: this.$route.query.type == 'CG03' ? 0 : formData.totalAmount,
            departmentCode: this.userInfo.departmentCode,
            departmentName: this.userInfo.departmentName,
            lastestReceiveProductDay: formData.lastestReceiveProductDay
              ? formData.lastestReceiveProductDay
              : null,
            lastestPayMoneyDay: formData.lastestPayMoneyDay ? formData.lastestPayMoneyDay : null,
            lastestSendProductDay: formData.lastestSendProductDay
              ? formData.lastestSendProductDay
              : null,
            // orderInterest: filterEmpty(orderInterest),
            orderOverdueInterestList,
            contractDetailCategory: this.$route.query.type,
            contractCategory: this.$route.query.contractCategory, // 代表销售还是合同
            orderContractRelationshipList,
            orderDetailList,
            orderDetailDelIds: this.orderDetailDelIds,
            attachmentList,
            tenantCode: this.userInfo.tenantCode,
            tenantName: this.userInfo.tenantName,
            companyName: formData?.contractBusinessCompanyName
              ? formData?.contractBusinessCompanyName
              : null,
            companyCode: formData?.contractBusinessCompanyNo
              ? formData?.contractBusinessCompanyNo
              : null,
            type,
            // 新增字段根据表格来合计
            businessContractUnitPrice: businessContractUnitPrice ? businessContractUnitPrice : 0,
            // businessContractUnitPriceLocal: '0',
            businessContractTotalAmount: businessContractTotalAmount
              ? businessContractTotalAmount
              : 0,
            // businessContractTotalAmountLocal: 210,
            businessContractTaxAmount: businessContractTaxAmount
              ? Number(businessContractTaxAmount)?.toFixed(6)
              : 0, // ?
            // businessContractTaxAmountLocal: 23.84,
            businessContractPureAmount: businessContractPureAmount ? businessContractPureAmount : 0, // ?
            // businessContractPureAmountLocal: 187.16,
            businessChangeUnitPrice: businessChangeUnitPrice ? businessChangeUnitPrice : 0,
            // businessChangeUnitPriceLocal: '0',
            businessChangeTotalAmount: businessChangeTotalAmount ? businessChangeTotalAmount : 0, // ?
            // businessChangeTotalAmountLocal: 210,
            businessChangeTaxAmount: businessChangeTaxAmount ? businessChangeTaxAmount : 0, // ?
            // businessChangeTaxAmountLocal: 23.84,
            businessChangePureAmount: businessChangePureAmount ? businessChangePureAmount : 0, // ?
            // businessChangePureAmountLocal: 186.16,
            oaId: this.userInfo.oaId, // 走oa审批的id
          };
          if (this.$route.query.copyFlag) {
            postData.copyFlag = this.$route.query.copyFlag;
          }
          if (
            this.$route.query.relationContractDetailCategory &&
            this.$route.query.relationContractDetailCategory.length
          ) {
            postData.relationContractDetailCategory =
              this.$route.query.relationContractDetailCategory;
          }
          this.loading.startLoading();
          const { data } = await this.$axios.post(ORDER_API.SAVE_ORDER_API, postData);
          this.loading.endLoading();
          if (data.code == 0) {
            this.$message.success(data.msg);
            this.$router.push({ path: '/salePurchase/saleOverview' });
          } else {
            this.$message.error(data.msg);
          }
        } else {
          this.$message.error('请检查填写数据');
        }
      });
    },
    // 拷贝功能
    copyHandler(type) {
      console.log('拷贝', type);
      const path = {
        path:
          type == 'agreement'
            ? '/salePurchase/saleAgreementCreation'
            : 'salePurchase/saleContractCreation',
        name: type == 'agreement' ? 'saleAgreementCreation' : 'saleContractCreation',
        meta: {
          keepAlive: false,
          title: type == 'agreement' ? '销售协议创建' : '销售合同创建',
        },
        query: {
          type: this.$route.query.type,
          isEdit: false,
          isCopy: true,
          contractNo: this.$route.query.contractNo,
          contractCategory: this.$route.query.contractCategory,
          dataGroup: this.$globalVar.dataGroup,
          copyFlag: '0',
        },
      };
      this.$router.push(path);
      // this.$store.dispatch('tagsView/addTabView', path).then(() => {
      //   this.$nextTick(() => {});
      // });
    },
    // 创建合同
    createContractHandler() {
      if (this.contractStatus != 'ZT03') {
        this.$message({
          showClose: true,
          message: '请选择一条已生效的合同进行创建',
          type: 'error',
        });
        return;
      }

      // 跳转到创建合同
      const path = {
        path: 'salePurchase/saleContractCreation',
        name: 'saleContractCreation',
        meta: {
          keepAlive: false,
          title: '创建销售合同',
        },
        query: {
          type: 'CG04',
          isEdit: false,
          contractCategory: 'sales',
          copy: true,
          copyFlag: '0',
          relationContractDetailCategory: 'CG04',
          contractNo: this.$route.query.contractNo,
        },
      };
      this.$store.dispatch('tagsView/addTabView', path).then(() => {
        this.$nextTick(() => {
          this.$router.push(path);
        });
      });
    },
    // 删除功能
    deleteHandler() {
      this.$confirmAction()
        .then(() => {
          this.loading.startLoading();
          this.$axios
            .post(ORDER_API.DELETE_ORDER_API, {
              ids: [this.$route.query.id],
              contractNos: [this.$route.query.contractNo],
              oaId: this.userInfo.oaId,
            })
            .then((res) => {
              this.loading.endLoading();
              if (0 == res.data.code) {
                this.$message({
                  type: 'success',
                  message: '操作成功',
                });
                this.$router.push({ path: '/salePurchase/saleOverview' });
              } else {
                this.$alert(res.data.msg);
              }
            });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消',
          });
        });
    },
    // 关闭、激活、撤销
    updateStatusHandler(type) {
      const { generateOrderStatus, generateNo } = this.detailPageData;
      if (type == 2 && generateNo) {
        this.$message({
          message: `关联合同号${generateNo}状态为${generateOrderStatus}`,
          type: 'error',
        });
        return;
      }
      this.$confirm('确定要更改合同状态？', '确认更改？', {})
        .then(async () => {
          this.loading.startLoading();
          //0-关闭 1-激活 2-撤销
          let postData = {
            id: this.$route.query.id,
            operateFlag: type,
            oaId: this.userInfo.oaId,
          };
          const res = await this.$axios.post(ORDER_API.UPDATE_OTDER_STATUS, postData);
          this.loading.endLoading();
          if (0 == res.data.code) {
            this.$message({
              type: 'success',
              message: '操作成功',
            });
            this.$router.push({ path: '/salePurchase/saleOverview' });
          } else {
            this.$alert(res.data.msg);
          }
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消',
          });
        });
    },
    // 创建提单 TODO
    createBillHandler() {
      if (this.contractStatus != 'ZT03') {
        this.$message({
          showClose: true,
          message: '请选择一条已生效的合同进行创建提单',
          type: 'error',
        });
        return;
      }

      this.loading.startLoading();
      this.$axios
        .post(ORDER_API.CHECK_ORDER_API, {
          contractNo: this.$route.query.contractNo,
          contractDetailCategory: this.$route.query.type,
        })
        .then((res) => {
          this.loading.endLoading();
          if (0 == res.data.code) {
            //跳转到销售提单页面
            let path = {
              path: '/salePurchase/salesLadingbillAdd',
              name: 'salesLadingbillAdd',
              meta: {
                keepAlive: false,
                title: '销售提单创建',
              },
              query: {
                contractNo: this.$route.query.contractNo,
              },
            };
            this.$store.dispatch('tagsView/addTabView', path).then(() => {
              this.$nextTick(() => {
                this.$router.push(path);
              });
            });
          } else {
            this.$alert(res.data.msg);
          }
        });
    },
  },
  mounted() {
    let isEdit = this.$route.query?.isEdit;

    if ((!isEdit || isEdit == 'false') && !this.$route.query.contractNo) {
      console.log(this.userInfo, '---用户-->>');
      this.baseFormData = {
        ...this.baseFormData,
        //默认货币
        companyCurrency: 'CNY',
        companyCurrencyName: '中国人民币（国际）',
        contractCurrency: 'CNY',
        contractCurrencyName: '中国人民币（国际）',
      };
    }
    if (this.$route.query.contractNo) {
      //获取详情
      this.getOrderDetail();
    }
  },
};
